import {Platform} from 'react-native';
import {client} from '../helpers/api';

export async function postEditKidProfile({studentName, gradeId, kidId, image}) {
  const body = new FormData();
  body.append('student_name', studentName);
  body.append('grade', gradeId);
  body.append('kid_id', kidId);

  if (image) {
    if (Platform.OS === 'web') {
      body.append('kids_image', image);
    } else {
      body.append('kids_image', {
        name: image.fileName,
        type: image.type,
        uri:
          Platform.OS === 'android'
            ? image.uri
            : image.uri.replace('file://', ''),
      });
    }
  }

  const response = await client.post('/api/kids/edit-profile', body, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    return response.data?.message || '';
  }
  throw response;
}
